import ShopItemComponent from "@/components/ShopItemComponent";
import { Skeleton } from "@/components/ui/skeleton";
import { useComponent } from "@/hooks/useMicrositeComponent";
import { cn } from "@/lib/utils";
import {
  IMicrositeComponent,
  MComponentShopListingProps,
} from "@/types/microsite";
import { ListIcon } from "lucide-react";
import { Fragment } from "react";
import useSWR from "swr";

const ShopListing = {
  kind: "SHOP_LISTING",
  Render: ({ id, isBuilder, data }) => {
    const { focusTo } = useComponent();

    const {
      data: __data,
      isLoading,
      error,
    } = useSWR(
      data.listingId ? "/microsite/shop/listing/" + data.listingId : null,
      {
        revalidateOnFocus: true,
        shouldRetryOnError: false,
      }
    );

    const items = __data?.data || [];

    return (
      <div
        id={id}
        onClick={() => {
          if (id && isBuilder) {
            focusTo(id);
          }
        }}
        className="relative flex flex-wrap w-full"
      >
        {isBuilder ? <div className="absolute inset-0" /> : <Fragment />}
        {isLoading ? (
          <>
            {[...new Array(4)].map((_, i) => (
              <div className="mb-4 px-2 w-6/12" key={i}>
                <div className="bg-white rounded-md overflow-hidden" key={i}>
                  <Skeleton className="pb-[120%]" />
                  <div className="p-4">
                    <Skeleton className="w-full h-6" />
                    <Skeleton className="mt-2 w-9/12 h-3" />
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : items.length === 0 ? (
          <div className="mb-4 px-2 w-full">
            <div className="bg-white p-4 rounded-md w-full overflow-hidden">
              <div className="pb-[100%]" />
              <div className="absolute inset-0 flex flex-col justify-center items-center text-black">
                <ListIcon className="mb-3 size-6" />
                <p>No Listing found</p>
              </div>
            </div>
          </div>
        ) : (
          items.map((item, index) => (
            <div
              // id={id}
              // onClick={() => {
              //   if (id && isBuilder) {
              //     focusTo(id);
              //   }
              // }}
              key={index}
              className={cn(
                "flex flex-col mb-4 px-2",
                data.style === "2-column" ? "w-6/12" : "w-full"
              )}
            >
              <ShopItemComponent
                key={index}
                itemId={item.id}
                itemStyle="1-column"
                data={item}
                id={item.id}
              />
            </div>
          ))
        )}
      </div>
    );
  },
} as IMicrositeComponent<MComponentShopListingProps>;

export default ShopListing;
